import { createSlice } from '@reduxjs/toolkit';

const stored = (() => {
  try {
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    return { token, user };
  } catch { return { token: null, user: null }; }
})();

const authSlice = createSlice({
  name: 'auth',
  initialState: { token: stored.token, user: stored.user, otpRequest: null },
  reducers: {
    setCredentials(state, action) {
      state.token = action.payload.token;
      state.user = action.payload.user;
      localStorage.setItem('token', action.payload.token);
      localStorage.setItem('user', JSON.stringify(action.payload.user));
    },
    setOtpRequest(state, action) {
      // Stores the full request payload (email + mobile + full_name) so
      // OTPVerify can resend with the exact same fields the validator requires.
      state.otpRequest = action.payload;
    },
    logout(state) {
      state.token = null;
      state.user = null;
      state.otpRequest = null;
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    },
  },
});

export const { setCredentials, setOtpRequest, logout } = authSlice.actions;
export default authSlice.reducer;
